import { useEffect } from "react"
import { router } from "@inertiajs/react"
import { toast } from "@/components/ui/sonner"

export function FlashMessages() {
  useEffect(() => {
    const removeListener = router.on("success", (event) => {
      const flash = event.detail.page.props.flash

      if (flash?.notice) {
        toast.success(flash.notice)
      }

      if (flash?.alert) {
        toast.error(flash.alert)
      }
    })

    return () => removeListener()
  }, [])

  return null
}
